import { connect } from 'react-redux';
import View from './AreYouMarriedView';
import {
  currentClientId,
  data2,
  data as dataSelector,
  isPopulatedSelector,
  isGoingForwardSelector,
} from '../../AdvWorkflow/AdvWorkflowSelector';
import { updateData, updateSupportData } from '../../AdvWorkflow/AdvWorkflowActions';
import { BACKEND_KEY } from '../PersonalInfoWorkflowConstants';
import { personalInfoSelector } from '../PersonalInfoWorkflowSelector';
import nextIteratorsSelector, { dirtyGraphNodesSelector } from './AreYouMarriedSelector';

const mapStateToProps = (state, ownProps) => ({
  clientId: currentClientId(state, ownProps),
  hasPartner: data2(state, ownProps)(`${BACKEND_KEY}.HasPartner`),
  partner: dataSelector(state, ownProps)(`${BACKEND_KEY}.Partner`),
  alreadyHadPartnerData: !!data2(state, ownProps)(`${BACKEND_KEY}.AlreadyHadPartnerData`),
  isPopulated: isPopulatedSelector(state, ownProps),
  isGoingForward: isGoingForwardSelector(state, ownProps),
  personalInfo: personalInfoSelector(state, ownProps),
  nextIterators: nextIteratorsSelector(state, ownProps),
  dirtyGraphNodes: dirtyGraphNodesSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  hasPartnerClicked: (clientId, store, store2) => (event) => {
    store2(
      {
        [BACKEND_KEY]: {
          HasPartner: event.target.checked,
        },
      },
      clientId,
    );
  },
  store: workflowId => (data, clientId) => dispatch(updateData(data, workflowId, clientId)),
  store2: workflowId => (data, clientId) => dispatch(updateSupportData(data, workflowId, clientId)),
  onPostProcess: hasPartner => (data) => {
    if (hasPartner === false) {
      return {
        ...data,
        [BACKEND_KEY]: {
          ...data[BACKEND_KEY],
          Partner: null,
        },
      };
    }
    return data;
  },
  onPostSave: workflowId => (data) => {
    dispatch(updateData(data, workflowId));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);
